export default __webpack_public_path__ + "static/media/mass_spring.d6321848.svg";